<template>
  <!-- <div class="street" :class="{active: active, deselected: deselected}">
    <p>{{ street.name }}</p>
    <select v-model="selected" @click.stop>
      <option value="" disabled selected>{{ $t("streetEntry.num") }}</option>
      <option v-for="nr in houseNumbers" :key="nr.id" :value="nr.hnr">{{ nr.hnr }}</option>
    </select>
  </div> -->
  <div class="street" :class="{active: active, deselected: deselected}">
    <p>{{ street.name }}</p>

    <select v-if="hasDbHouseNumbers" v-model="selected" @click.stop>
      <option value="" disabled selected>{{ $t("streetEntry.num") }}</option>
      <option v-for="nr in houseNumbers" :key="nr.id" :value="nr.hnr">
        {{ nr.hnr }}
      </option>
    </select>
  </div>
</template>

<script>
import {basemap} from "@/services/map/basemap";
import M2wApi from "@/services/m2w_api";

export default {
  name: "StreetEntry",
  props: ["street", "active", "deselected"],
  data() {
    return {
      houseNumbers: [],
      activeLine: null,
      activeMarker: null,
      selected: "",
      hnr: null,
      hasDbHouseNumbers: false,
    };
  },
  watch: {
    active: async function (val, oldval) {
      if (val != oldval) {
        this.cleanup();
      }
      await this.onActiveFunc();
    },

    selected: function (val) {
      if (val !== "" && this.$route.query.hnr !== val) {
        this.$router.replace({query: {...this.$route.query, hnr: val}});
        this.hnrFromQuery();
      }
    },

    "$route.query.hnr": function () {
      this.hnrFromQuery();
    },
  },

  async mounted() {
    await this.onActiveFunc();
  },
  async activated() {
    await this.onActiveFunc();
  },
  deactivated() {
    this.cleanup();
  },
  destroyed() {
    this.cleanup();
  },

  methods: {
    // async onActiveFunc() {
    //   if (this.activeLine) basemap.map.removeLayer(this.activeLine);
    //   if (!this.active) return;

    //   this.activeLine = basemap.drawLine(this.street.geom);
    //   const extent = this.activeLine.getSource().getExtent();
    //   basemap.map.getView().fit(extent, { duration: 1000 });

    //   if (this.houseNumbers.length === 0) {
    //     this.houseNumbers = (await M2wApi.get_single_street(this.street.id)).house_numbers;
    //   }

    //   const g = this.street.geom;
    //   let geometry;

    //   if (g?.type === "LineString") {
    //     geometry = { type: "LineString", coordinates: g.coordinates };
    //   } else if (g?.type === "MultiLineString") {
    //     geometry = { type: "MultiLineString", coordinates: g.coordinates };
    //   } else {
    //     return;
    //   }
    //   const featureStreet = {
    //   type: "Feature",
    //   geometry,
    //   properties: {
    //     name: this.street.name,
    //     streetId: this.street.id,
    //     line_color: "#ff0000",
    //     width: 4,
    //     addStartStop: true,
    //     role: "street",
    //     }
    //   };
    //   this.$root.$emit("poiSelectedFromList", featureStreet);

    //   this.$el.scrollIntoView({ block: "nearest" });
    //   this.hnrFromQuery();
    // },

    // hnrFromQuery() {
    //   if (this.activeMarker) basemap.map.removeLayer(this.activeMarker);
    //   if (!this.active) return;

    //   const hnr = this.$route.query.hnr;
    //   const num = this.houseNumbers.find((x) => x.hnr === hnr);
    //   if (!num) return;

    //   this.hnr = num;
    //   this.selected = hnr;

    //   this.activeMarker = basemap.createMarkerForCoordinates(num.geom.coordinates);
    //   basemap.map.getView().animate({ center: num.geom.coordinates, duration: 200 });

    //   const to4326 = ([x, y]) => {
    //     const is3857 = Math.abs(x) > 180 || Math.abs(y) > 90;
    //     if (!is3857) return [x, y];
    //     const R = 6378137;
    //     const lon = (x / R) * 180 / Math.PI;
    //     const lat = (2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * 180 / Math.PI;
    //     return [lon, lat];
    //   };

    //   const coords4326 = to4326(num.geom.coordinates);

    //   const feature = {
    //     type: "Feature",
    //     geometry: { type: "Point", coordinates: coords4326 }, // [lng, lat]
    //     properties: {
    //       role: "hnr",
    //       name: `${this.street.name} ${hnr}`,
    //       // poți lăsa fără icon și WeatherMTK pune id: "marker",
    //       // sau setezi o iconiță proprie:
    //       // icon: "https://…/hnr-pin.png"
    //     },
    //   };

    //   this.$root.$emit("poiSelectedFromList", feature);
    // },
    async onActiveFunc() {
      if (this.activeLine) {
        basemap.map.removeLayer(this.activeLine);
        this.activeLine = null;
      }

      console.log("STREET source:", this.street.source);
      console.log("STREET isOsm:", this.street.isOsm);
      console.log("STREET id:", this.street.id);
      console.log("STREET name:", this.street.name);

      if (!this.active) return;

      // if (this.street.source === "google_maps") {
      //   this.houseNumbers = [];

      //   if (this.street.lat && this.street.lng) {
      //     const lon = this.street.lng;
      //     const lat = this.street.lat;

      //     const x = (lon * 20037508.34) / 180;
      //     let y =
      //       Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) /
      //       (Math.PI / 180);
      //     y = (y * 20037508.34) / 180;

      //     basemap.map.getView().animate({
      //       center: [x, y],
      //       zoom: 17,
      //       duration: 700,
      //     });

      //     this.$root.$emit("poiSelectedFromList", {
      //       type: "Feature",
      //       geometry: {
      //         type: "Point",
      //         coordinates: [lon, lat],
      //       },
      //       properties: {
      //         role: "street",
      //         name: this.street.name,
      //         source: "google_maps",
      //       },
      //     });
      //   }

      //   this.$el.scrollIntoView({
      //     block: "nearest",
      //   });

      //   return;
      // }
      if (this.street.source === "google_maps") {
        this.houseNumbers = [];

        this.$el.scrollIntoView({
          block: "nearest",
        });

        return;
      }

      if (this.street.geom) {
        this.activeLine = basemap.drawLine(this.street.geom);

        const extent = this.activeLine.getSource().getExtent();

        basemap.map.getView().fit(extent, {
          duration: 1000,
        });
      }

      if (this.street.isOsm || this.street.source === "google_maps") {
        this.houseNumbers = [];
        this.hasDbHouseNumbers = false;
      } else {
        const result = await M2wApi.get_single_street(this.street.id);

        this.houseNumbers = result.house_numbers || result.houseNumbers || result.hnrs || [];

        this.hasDbHouseNumbers = this.houseNumbers.length > 0;
      }

      if (this.street.geom) {
        const g = this.street.geom;
        let geometry = null;

        if (g.type === "LineString") {
          geometry = {
            type: "LineString",
            coordinates: g.coordinates,
          };
        } else if (g.type === "MultiLineString") {
          geometry = {
            type: "MultiLineString",
            coordinates: g.coordinates,
          };
        }

        if (geometry) {
          this.$root.$emit("poiSelectedFromList", {
            type: "Feature",
            geometry,
            properties: {
              name: this.street.name,
              streetId: this.street.id,
              line_color: "#ff0000",
              width: 4,
              addStartStop: true,
              role: "street",
            },
          });
        }
      }

      this.$el.scrollIntoView({
        block: "nearest",
      });

      this.hnrFromQuery();
    },

    normalizeStreetName(value) {
      return String(value || "")
        .split(",")[0]
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\b(strada|str\.|str)\b/g, "")
        .replace(/[^a-z0-9 ]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    },

    async getOsmHouseNumbersNearStreet() {
      const geometry = this.street.geom;
      if (!geometry || !geometry.coordinates) return [];

      const lineCoords = geometry.type === "MultiLineString" ? geometry.coordinates.flat() : geometry.coordinates;

      const wantedStreet = this.normalizeStreetName(this.street.name);

      const samplePoints = lineCoords
        .filter((_, index) => index % 3 === 0)
        .map((point) => {
          const lon = Number(point[0]);
          const lat = Number(point[1]);

          if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
          return {lon, lat};
        })
        .filter(Boolean);

      if (!samplePoints.length) return [];

      const aroundQueries = samplePoints
        .map(
          ({lat, lon}) => `
    node(around:70,${lat},${lon})["addr:housenumber"];
    way(around:70,${lat},${lon})["addr:housenumber"];
    relation(around:70,${lat},${lon})["addr:housenumber"];
  `
        )
        .join("");

      const query = `
    [out:json][timeout:25];
    (
      ${aroundQueries}
    );
    out center tags;
  `;

      const response = await fetch("https://overpass-api.de/api/interpreter", {
        method: "POST",
        body: query,
      });

      const data = await response.json();
      const seen = new Set();

      return data.elements
        .filter((el) => el.tags && el.tags["addr:housenumber"])
        .filter((el) => {
          const addrStreet = this.normalizeStreetName(el.tags["addr:street"]);
          return !addrStreet || addrStreet === wantedStreet;
        })
        .map((el, index) => {
          const lon = Number(el.lon || el.center?.lon);
          const lat = Number(el.lat || el.center?.lat);

          if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;

          const hnr = el.tags["addr:housenumber"];
          const key = `${hnr}-${lon}-${lat}`;

          if (seen.has(key)) return null;
          seen.add(key);

          return {
            id: `osm-hnr-${index}`,
            hnr,
            geom: {
              type: "Point",
              coordinates: [lon, lat],
            },
          };
        })
        .filter(Boolean)
        .sort((a, b) => String(a.hnr).localeCompare(String(b.hnr), undefined, {numeric: true}));
    },

    // async onActiveFunc() {
    //   if (this.activeLine) basemap.map.removeLayer(this.activeLine);
    //   if (!this.active) return;

    //   if (this.street.geom) {
    //     this.activeLine = basemap.drawLine(this.street.geom);
    //     const extent = this.activeLine.getSource().getExtent();
    //     basemap.map.getView().fit(extent, { duration: 1000 });
    //   }

    // //   if (this.houseNumbers.length === 0) {
    // //     if (this.street.isOsm) {
    // // this.houseNumbers = (this.street.hnrs || []).map((nr, index) => {
    // //   if (typeof nr === "string") {
    // //     return {
    // //       id: `osm-hnr-${index}`,
    // //       hnr: nr,
    // //       geom: null,
    // //     };
    // //   }

    // //   return {
    // //     id: nr.id || `osm-hnr-${index}`,
    // //     hnr: nr.hnr,
    // //     geom: nr.geom || null,
    // //   };
    // // });
    // //     } else {
    // //       this.houseNumbers = (await M2wApi.get_single_street(this.street.id)).house_numbers;
    // //     }
    // //   }
    // if (this.street.isOsm) {
    //   this.houseNumbers = (this.street.hnrs || []).map((nr, index) => {
    //     if (typeof nr === "string") {
    //       return {
    //         id: `osm-hnr-${index}`,
    //         hnr: nr,
    //         geom: null,
    //       };
    //     }

    //     return {
    //       id: nr.id || `osm-hnr-${index}`,
    //       hnr: nr.hnr,
    //       geom: nr.geom || null,
    //     };
    //   });
    // } else {
    //   const result = await M2wApi.get_single_street(this.street.id);

    //   console.log("STREET DB", this.street.id);
    //   console.log("HOUSE NUMBERS", result);

    //   this.houseNumbers =
    //     result.house_numbers ||
    //     result.houseNumbers ||
    //     result.hnrs ||
    //     [];
    // }

    //   if (this.street.geom) {
    //     const g = this.street.geom;
    //     let geometry;

    //     if (g?.type === "LineString") {
    //       geometry = { type: "LineString", coordinates: g.coordinates };
    //     } else if (g?.type === "MultiLineString") {
    //       geometry = { type: "MultiLineString", coordinates: g.coordinates };
    //     }

    //     if (geometry) {
    //       const featureStreet = {
    //         type: "Feature",
    //         geometry,
    //         properties: {
    //           name: this.street.name,
    //           streetId: this.street.id,
    //           line_color: "#ff0000",
    //           width: 4,
    //           addStartStop: true,
    //           role: "street",
    //         },
    //       };

    //       this.$root.$emit("poiSelectedFromList", featureStreet);
    //     }
    //   }

    //   this.$el.scrollIntoView({ block: "nearest" });
    //   this.hnrFromQuery();
    // },

    hnrFromQuery() {
      if (this.activeMarker) basemap.map.removeLayer(this.activeMarker);
      if (!this.active) return;

      const hnr = this.$route.query.hnr;
      const num = this.houseNumbers.find((x) => x.hnr === hnr);
      if (!num) return;

      this.hnr = num;
      this.selected = hnr;

      if (!num.geom || !num.geom.coordinates) return;

      this.activeMarker = basemap.createMarkerForCoordinates(num.geom.coordinates);
      basemap.map.getView().animate({
        center: num.geom.coordinates,
        duration: 200,
      });

      const to4326 = ([x, y]) => {
        const is3857 = Math.abs(x) > 180 || Math.abs(y) > 90;
        if (!is3857) return [x, y];

        const R = 6378137;
        const lon = ((x / R) * 180) / Math.PI;
        const lat = ((2 * Math.atan(Math.exp(y / R)) - Math.PI / 2) * 180) / Math.PI;

        return [lon, lat];
      };

      const coords4326 = to4326(num.geom.coordinates);

      const feature = {
        type: "Feature",
        geometry: {type: "Point", coordinates: coords4326},
        properties: {
          role: "hnr",
          name: `${this.street.name} ${hnr}`,
        },
      };

      this.$root.$emit("poiSelectedFromList", feature);
    },

    async chooseHnr(num_obj) {
      await this.$router.push({query: {...this.$route.query, hnr: num_obj.hnr}});
    },
    cleanup() {
      this.selected = "";
      this.hnr = null;
      this.hasDbHouseNumbers = false;

      if (this.activeMarker) basemap.map.removeLayer(this.activeMarker);
      if (this.activeLine) basemap.map.removeLayer(this.activeLine);

      const query = {...this.$route.query};
      delete query.hnr;

      this.$router.replace({query}).catch((err) => {
        if (err.name !== "NavigationDuplicated") throw err;
      });
    },

    // cleanup() {
    //   this.selected = "";
    //   this.hnr = null;
    //   if (this.activeMarker) basemap.map.removeLayer(this.activeMarker);
    //   if (this.activeLine) basemap.map.removeLayer(this.activeLine);

    //   this.$router.replace({query: {...this.$route.query, hnr: null}});
    // },
  },
};
</script>

<style scoped></style>
